'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _userUtil = require('../../userUtil');

var _elementCountConstants = require('../../elementCount/elementCountConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanStatusTitle = function PlanStatusTitle(_ref) {
    var currentUser = _ref.currentUser,
        contentTotalCount = _ref.contentTotalCount,
        contentTotalLimit = _ref.contentTotalLimit;

    if ((0, _userUtil.isSubscribed)(currentUser)) {
        return _react2.default.createElement(
            'div',
            { className: 'plan-status' },
            'You\'re on the ',
            _react2.default.createElement(
                'span',
                { className: 'plan-name' },
                'Professional'
            ),
            ' plan'
        );
    }

    if (contentTotalCount >= contentTotalLimit) {
        return _react2.default.createElement(
            'div',
            { className: 'plan-status' },
            _react2.default.createElement(
                'span',
                { className: 'plan-name' },
                'Your workspace is full'
            )
        );
    }

    if (contentTotalCount >= contentTotalLimit - _elementCountConstants.ELEMENT_COUNT_WARNING_START) {
        return _react2.default.createElement(
            'div',
            { className: 'plan-status' },
            _react2.default.createElement(
                'span',
                { className: 'plan-name' },
                'Your workspace is almost full'
            )
        );
    }

    return _react2.default.createElement(
        'div',
        { className: 'plan-status' },
        'You\'re on the ',
        _react2.default.createElement(
            'span',
            { className: 'plan-name' },
            'Free'
        ),
        ' plan'
    );
};

PlanStatusTitle.propTypes = {
    currentUser: _propTypes2.default.object,
    contentTotalCount: _propTypes2.default.number,
    contentTotalLimit: _propTypes2.default.number
};

exports.default = PlanStatusTitle;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/plan/PlanStatusTitle.js
// module id = 754
// module chunks = 0